export interface IInboundAlias {
  enabled: boolean;
  alias_token?: string;
  full_address?: string;
  last_received_at?: string;
  count_7d: number;
}

export enum InboundEmailLogStatus {
  RECEIVED = 'received',
  PARSING = 'parsing',
  MATCHED = 'matched',
  MATCHED_BY_DOMAIN_FALLBACK = 'matched_by_domain_fallback',
  CANDIDATE_IMPORTED = 'candidate_imported',
  UNMATCHED_NO_ORG = 'unmatched_no_org',
  UNMATCHED_NO_JOB = 'unmatched_no_job',
  PARSE_FAILED = 'parse_failed',
  DUPLICATE = 'duplicate',
  REJECTED_SPOOF_RISK = 'rejected_spoof_risk',
}

export interface IInboundEmailLog {
  id: string;
  created_at: string;
  nylas_message_id: string;
  alias_token_used?: string;
  forwarder_domain?: string;
  from_email: string;
  subject?: string;
  parsed_data?: Record<string, any>;
  status: InboundEmailLogStatus;
  error_detail?: string;
  retention_purge_after: string;
  organization_id?: string;
  linked_application_id?: string;
  linked_candidate_id?: string;
}

export interface ListInboundEmailLogsParams {
  organizationId: string;
  page?: number;
  per_page?: number;
  status?: InboundEmailLogStatus;
  source_board?: string;
  date_from?: string;
  date_to?: string;
}

export interface ManuallyAssignParams {
  organizationId: string;
  logId: string;
  jobId: string;
}
